

























import {Component, Vue} from 'vue-property-decorator';
import Button from '@/components/commons/Button.vue';

@Component({
  components: {Button}
})
export default class Unauthorized extends Vue {
}
